import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import useDepartNow from '#/trip-planner/hooks/useDepartNow';
import { updateTripOptions } from '#/trip-planner/queries';
import { clearTripOptions as clearTripOptionsAction } from '#/trip-planner/slice';
import otpUiConfig from '#/otp-ui-config';
import useCurrentQuery from '#/trip-planner/hooks/useCurrentQuery';

const useTripOptions = () => {
  const { currentQuery } = useCurrentQuery();
  const { plan, planError } = useSelector(s => s.tripPlanner);
  const dispatch = useDispatch();
  const { departNow, setTripDepartTimeToNow } = useDepartNow(null);
  const intl = useIntl();

  const refreshTripOptions = useCallback(() => {
    if (departNow) setTripDepartTimeToNow();
    dispatch(updateTripOptions(currentQuery, otpUiConfig, intl));
  }, [departNow, setTripDepartTimeToNow, dispatch, currentQuery, intl]);

  const clearTripOptions = useCallback(
    () => dispatch(clearTripOptionsAction()),
    [dispatch]
  );

  return { plan, planError, refreshTripOptions, clearTripOptions };
};

export default useTripOptions;
